import { render, staticRenderFns } from "./Portfolio.vue?vue&type=template&id=438f149a&scoped=true"
import script from "./Portfolio.vue?vue&type=script&lang=js"
export * from "./Portfolio.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/portfolio.less?vue&type=style&index=0&id=438f149a&prod&scoped=true&lang=less&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438f149a",
  null
  
)

export default component.exports